import React from 'react';
import { Chip } from '@mui/material';

/** The outcomes a user import gives each row, with their chips' labels and colours. */
export const USER_IMPORT_ROW_STATUSES = {
	created: { label: 'Created', color: 'success' },
	skipped: { label: 'Skipped', color: 'warning' },
	failed: { label: 'Failed', color: 'error' },
};

/** One import row's outcome as a coloured chip: created, skipped or failed. */
export const UserImportRowStatusChip = ({ status }) => (
	<Chip size='small' {...USER_IMPORT_ROW_STATUSES[status]} />
);
